import { render, staticRenderFns } from "./draggable2.vue?vue&type=template&id=5d21117a"
import script from "./draggable2.vue?vue&type=script&lang=js"
export * from "./draggable2.vue?vue&type=script&lang=js"
import style0 from "./draggable2.vue?vue&type=style&index=0&id=5d21117a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports